import type { PublicConfig } from '@de/shared'

/**
 * Key modes the UI offers, from /api/public/config. `keyModes` comes from the registry's adapters
 * (`dkgAdapter()` / `councilAdapter()` non-zero); null/absent means unknown right now, so the defaults apply and the
 * server (which re-checks at publish and start) decides.
 */
export const automaticOffered = (config: Pick<PublicConfig, 'keyModes'> | undefined): boolean =>
  config?.keyModes?.dkg !== false

export const committeesOffered = (config: Pick<PublicConfig, 'councilAppUrl' | 'keyModes'> | undefined): boolean =>
  Boolean(config?.councilAppUrl) && config?.keyModes?.council !== false
